module.exports = __webpack_public_path__ + "assets/img/g4.af9e10c1.png";